let pjson = require('../../package.json');

const VERSION = pjson.version;

export {VERSION}